import _objectSpread from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import { Column as RVColumn, Table as RVTable, SortIndicator, SortDirection } from 'react-virtualized';
import createMultiSort from './createMultiSort';
import CellMeasurerCache from 'react-virtualized/dist/commonjs/CellMeasurer/CellMeasurerCache';
import CellMeasurer from 'react-virtualized/dist/commonjs/CellMeasurer/CellMeasurer';
import defaultRowRenderer from 'react-virtualized/dist/commonjs/Table/defaultRowRenderer'; // import { hasPermission } from '@defi/core-auth';

import { Cell, HeaderCell, HeaderRow } from './';
import Auth from '@defi/core-auth';
import { List, fromJS } from 'immutable';
import TableContext from './TableContext';

var hasPermission = function hasPermission(permission) {
  return Auth.checkPermissions(List([permission]));
};

function sort(_ref) {
  var defaultSortDirection = _ref.defaultSortDirection,
      event = _ref.event,
      sortDirection = _ref.sortDirection,
      sortBy = _ref.sortBy,
      list = _ref.list;
  var sortedRows = list; // flip the direction if already sorted ASC

  var currentSortDirection = sortDirection[sortBy[0]];
  var asc = currentSortDirection === 'ASC';
  sortedRows = list.sort(function (a, b) {
    var first = a.get('cell').find(function (cell, i) {
      return i.toString() === sortBy[0];
    }).get('value');
    var second = b.get('cell').find(function (cell, i) {
      return i.toString() === sortBy[0];
    }).get('value');

    if (asc) {
      if (first < second) return -1;
      if (first > second) return 1;
      if (first === second) return 0;
    } else {
      if (first < second) return 1;
      if (first > second) return -1;
      if (first === second) return 0;
    }

    return null;
  });
  return {
    sortedRows: sortedRows,
    sortDirection: sortDirection,
    sortBy: sortBy
  };
}

;

var Table =
/*#__PURE__*/
function (_Component) {
  _inherits(Table, _Component);

  function Table(props) {
    var _this;

    _classCallCheck(this, Table);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Table).call(this, props));
    _this.cache = new CellMeasurerCache({
      fixedWidth: true,
      minHeight: 40
    });

    _this.headerRenderer = function (_ref2) {
      var dataKey = _ref2.dataKey,
          label = _ref2.label;
      dataKey = dataKey.toString();

      var showSortIndicator = _this.sortState.sortBy.includes(dataKey);

      return React.createElement(React.Fragment, null, React.createElement("span", {
        title: label
      }, label), showSortIndicator && React.createElement(SortIndicator, {
        sortDirection: _this.sortState.sortDirection[dataKey]
      }));
    };

    _this.useSort = function (list, filterRows, sortState) {
      if (!_this.sortState) {
        _this.sortState = createMultiSort(function (args) {
          return filterRows(_objectSpread({}, args, {
            sortState: _this.sortState,
            sortEffect: sort(_objectSpread({}, args, {
              list: list
            }))
          }));
        });
      }

      return function (args) {
        return _this.sortState.sort(_objectSpread({}, args, {
          sortDirection: sortState && sortState.sortDirection ? sortState.sortDirection : undefined
        }));
      };
    };

    _this.rowRenderer = _this.rowRenderer.bind(_assertThisInitialized(_this));
    _this.rvTable = null;
    _this.sortState = null;
    return _this;
  }

  _createClass(Table, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.width !== this.props.width || prevProps.rows !== this.props.rows) {
        this.cache.clearAll();
      }
    }
  }, {
    key: "renderBodyCell",
    value: function renderBodyCell(params) {
      var dataKey = params.dataKey,
          rowData = params.rowData,
          rowIndex = params.rowIndex,
          parent = params.parent;
      var col = rowData.getIn(['cell', dataKey]);
      var appId = rowData.get('id');
      var subId = rowData.get('subid');
      var link = this.props.link ? subId ? this.props.link(appId, subId) : this.props.link(appId) : false;
      var header = col ? col.get('header') : '';
      var value = col ? col.get('value') : '';
      return React.createElement(CellMeasurer, {
        cache: this.cache,
        columnIndex: dataKey,
        key: dataKey,
        parent: parent,
        rowIndex: rowIndex
      }, React.createElement(Cell, {
        header: header,
        link: link,
        appId: appId,
        rowData: rowData,
        index: rowIndex,
        custom: this.props.config.custom,
        colData: col
      }, value));
    }
  }, {
    key: "renderColumns",
    value: function renderColumns(useHeader) {
      var _this2 = this;

      return this.props.children.get('headers').map(function (header, i) {
        var custom = _this2.props.config.custom ? _this2.props.config.custom.find(function (col) {
          return col.header === header.get('id');
        }) : false;

        if (custom && custom.permission) {
          if (!custom.permission) {
            return null;
          }
        }

        var width = custom && custom.width ? custom.width : 2000;
        return React.createElement(RVColumn, {
          key: i,
          label: header.get('label'),
          dataKey: i,
          width: width,
          headerRenderer: function headerRenderer(_ref3) {
            var dataKey = _ref3.dataKey,
                label = _ref3.label;
            return !useHeader ? null : _this2.headerRenderer({
              dataKey: dataKey,
              label: label
            });
          },
          cellRenderer: function cellRenderer(params) {
            return _this2.renderBodyCell(params);
          }
        });
      });
    }
  }, {
    key: "rowGetter",
    value: function rowGetter(index, list) {
      return list && list.size > 0 ? list.get(index) : null;
    }
  }, {
    key: "rowRenderer",
    value: function rowRenderer(rowProps) {
      if (this.props.preRowRender && typeof this.props.preRowRender === "function") {
        rowProps = this.props.preRowRender(rowProps);
      }

      if (this.props.customRowRenderer && typeof this.props.customRowRenderer === 'function') {
        return this.props.customRowRenderer(rowProps);
      } else {
        return defaultRowRenderer(rowProps);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          width = _this$props.width,
          rowHeight = _this$props.rowHeight,
          useSort = _this$props.useSort,
          useFooter = _this$props.useFooter,
          footer = _this$props.footer;
      return React.createElement(TableContext.Consumer, null, function (_ref4) {
        var filteredRows = _ref4.filteredRows,
            sortState = _ref4.sortState,
            filterRows = _ref4.filterRows,
            list = _ref4.list;
        var adjustedHeight = list ? 50 * (list.size + 1) : 0;
        if (filteredRows) list = filteredRows;
        return React.createElement("div", null, list && list.size > 0 && React.createElement(RVTable, {
          ref: function ref(node) {
            return _this3.rvTable = node;
          },
          autoHeight: true,
          deferredMeasurementCache: _this3.cache,
          overscanRowCount: 2,
          rowGetter: function rowGetter(_ref5) {
            var index = _ref5.index;
            return _this3.rowGetter(index, list);
          },
          rowHeight: rowHeight ? rowHeight : _this3.cache.rowHeight,
          height: adjustedHeight,
          rowCount: list ? list.size : 0,
          width: width,
          headerHeight: 35,
          headerStyle: {
            minHeight: 35,
            maxHeight: 35,
            padding: '10px 5px 5px 5px'
          },
          headerRowRenderer: function headerRowRenderer(params) {
            return React.createElement(HeaderRow, {
              params: params,
              width: width
            });
          },
          rowRenderer: _this3.rowRenderer,
          onRowClick: _this3.props.onRowClick,
          onRowsRendered: _this3.afterRowsRendered,
          sort: useSort ? _this3.useSort(list, filterRows, sortState) : undefined,
          sortBy: undefined,
          sortDirection: undefined
        }, _this3.renderColumns(true)), useFooter && footer.size > 0 && list && list.size > 0 && React.createElement(RVTable, {
          ref: function ref(node) {
            return _this3.rvTable = node;
          },
          deferredMeasurementCache: _this3.cache,
          overscanRowCount: 2,
          rowGetter: function rowGetter(_ref6) {
            var index = _ref6.index;
            return footer && footer.size > 0 ? footer.get(index) : null;
          },
          rowHeight: rowHeight ? rowHeight : _this3.cache.rowHeight,
          rowStyle: {
            fontSize: '16px',
            width: width
          },
          height: 40,
          rowCount: footer ? footer.size : 0,
          width: width,
          headerHeight: 0,
          headerStyle: {
            minHeight: '5px'
          },
          headerRowRenderer: function headerRowRenderer(params) {
            return React.createElement(HeaderRow, {
              params: params,
              width: width
            });
          },
          rowRenderer: _this3.rowRenderer,
          sort: undefined,
          sortBy: undefined,
          sortDirection: undefined
        }, _this3.renderColumns(false)));
      });
    }
  }]);

  return Table;
}(Component);

export default Table;